/**
 * group-worklists-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message, ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class GroupWorklistsRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_GROUP_WORKLISTS;
  public static tag : MessageTag = MessageTag.REQ_GROUP_WORKLISTS;

  /**
   * Construct a new {@link GroupWorklistsRequest}.
   */
  constructor (
    public groupId : number
  )
  {
    super();
  }

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_GROUP_WORKLISTS);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/watchlists/group-worklists-request.ts